import React from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { LiveStatusBadge } from "./LiveStatusBadge";
import _ from "lodash";
import TeamLogo from "../TeamLogo";
import frontend from "../../../../../config/frontend";
import { isSDMatchFinished, isSDMatchLive } from "./bildMatchLive";


const MatchTime = ({ matchInfo, t }) => {
    const matchTime = parseInt(_.get(matchInfo, "MinuteOfPlay", 0));
    return matchTime ? (
        <span className={"match-score-time score-time-sd"}>
            {matchTime}. {t("min")}
        </span>
    ) : null;

};

export const MatchScoreWidget = ({
    homeTeam,
    awayTeam,
    matchInfo = {},
    hideLive = false,
    isAlarm = false,
    alarmScores = null
}) => {
    const { MatchStatus, Result } = matchInfo || {};
    const resultSplit = Result?.split(':');
    const homeScore = parseInt(resultSplit?.[0]);
    const awayScore = parseInt(resultSplit?.[1]);
    let scores = {
        home: homeScore,
        away: awayScore
    }
    if (alarmScores) {
        scores = alarmScores;
    }
    const { t } = useTranslation();
    const finished = MatchStatus === 'finalWhistle';
    const isPlaying = isSDMatchLive(matchInfo?.['KickOff'], finished) 
    const isTimeFinished = isSDMatchFinished(matchInfo?.['KickOff']);
    return (
        <div className={"comp-match-score-widget"}>
            <div className={"widget-container"}>
                <div className={`logo-container home ${isAlarm ? "isAlarm" : ""}`}>
                    <TeamLogo team={homeTeam} />
                    <div className={"team-name home"}>
                        {t(homeTeam?.TeamName, { ns: "countries" })}
                    </div>
                </div>
                {(finished || isPlaying || isTimeFinished || isAlarm)
                    ? (
                        <div className="score-container container-sd">
                            <div className={"score"}>
                                <div className={"score-home"}>{scores?.home || 0}</div>
                                <div className={"separator"}>{":"}</div>
                                <div className={"score-away"}>{scores?.away || 0}</div>
                                {(!isAlarm && isPlaying && !hideLive) && <LiveStatusBadge className="live-status-sd" />}
                            </div>
                            {(isPlaying && !hideLive) ? (
                                <MatchTime
                                    matchInfo={matchInfo}
                                    t={t}
                                />
                            ) : null}
                        </div>
                    ) : (
                        <div className={"team-vs"}>
                            <div className={"versus"}>{t("templates.vs")}.</div>
                        </div>
                    )}
                <div className={`logo-container away ${isAlarm ? "isAlarm" : ""}`}>
                    <TeamLogo team={awayTeam} />
                    <div className={"team-name away"}>
                        {t(awayTeam?.TeamName, { ns: "countries" })}
                    </div>
                </div>
            </div>
        </div>
    );
};
